import { arrayMove } from '@dnd-kit/sortable';

export function getReorderedUpdates(ids, activeId, overId, entries) {
  if (!overId || activeId === overId) return [];

  const oldIndex = ids.indexOf(activeId);
  const newIndex = ids.indexOf(overId);
  const newOrder = arrayMove(ids, oldIndex, newIndex);

  return newOrder.map((providerId, index) => {
    const entry = entries.find((e) => e.providerId === providerId);
    return {
      name: `screeningSetupData.${entry.providerName}.order`,
      value: index + 1, // Order starts from 1
    };
  });
}
